import type { Props } from "../../../../props";

type Area = Props["groupedPrefectures"][number];

export const convertStateForAreaCheckbox =
  (code: string) =>
  (area: Area): Area => {
    const { code: areaCode, isAreaChecked, prefectures } = area;
    if (areaCode !== code) return area;
    const newPrefectures =
      prefectures.length > 0
        ? prefectures.map((prefecture) => ({
            ...prefecture,
            isPrefectureChecked: !isAreaChecked,
          }))
        : prefectures;
    return {
      ...area,
      isAreaChecked: !isAreaChecked,
      prefectures: newPrefectures,
    };
  };
